import React from "react";
import { sum } from "lodash";
import { formatCurrency } from "../../../../utils/format";
import { color } from "../../../../shared/styles";

interface SummaryProps {
    data: any[];
    materials?: any[];
    orderState?: string;
}

const Summary = ({ data = [], materials = [], orderState = "Open" }: SummaryProps) => {
    const allItems = [...data, ...materials];

    const getItemPrice = (item: any) => {
        if (item.item_type === "material") {
            return item.material_price || 0;
        }
        return item.product_price || 0;
    };

    // Pre-tax base per line after discount, using integer math to avoid float + ceil drift.
    const calculateLineBase = (item: any) => {
        const price = getItemPrice(item) || 0;
        const discount = item.discount || 0;
        const qty = item.selectedQuantity || 0;
        return Math.ceil((price * (100 - discount)) / 100) * qty;
    };
    const calculateLineTax = (item: any) => {
        const markup = item.markup || 0;
        return Math.ceil((calculateLineBase(item) * markup) / 100);
    };

    const discountPrice = sum(allItems.map(calculateLineBase));
    const amountTax = sum(allItems.map(calculateLineTax));
    const finalPrice = discountPrice + amountTax;
    const totalPrice = sum(allItems.map((item: any) => getItemPrice(item) * (item.selectedQuantity || 0)));

    const amountDiscount = totalPrice - discountPrice;

    const productCount = data.length;
    const materialCount = materials.length;
    const isOpenState = orderState === "Open";

    return (
        <div className="tw-rounded-md tw-bg-white tw-p-6 tw-shadow-sm tw-space-y-3"
             style={{ border: `1px solid ${color.secondary.BORDER}` }}>
            <div className="tw-flex tw-items-center tw-justify-between">
                <div className="tw-text-xl tw-font-semibold tw-text-gray-900">Tổng đơn hàng</div>
            </div>

            <div className="tw-grid tw-grid-cols-2 tw-text-md tw-leading-6 tw-px-1">
                <div className="tw-py-1 tw-text-gray-600">Giá ({productCount} sản phẩm, {materialCount} vật tư)</div>
                <div className="tw-py-1 tw-text-right">{formatCurrency(totalPrice)}</div>
            </div>

            {!isOpenState && (
                <>
                    <div className="tw-grid tw-grid-cols-2 tw-text-md tw-leading-6 tw-px-1">
                        <div className="tw-py-1 tw-text-gray-600">Chiết khấu</div>
                        <div className="tw-py-1 tw-text-right">- {formatCurrency(amountDiscount)}</div>
                    </div>
                    <div className="tw-grid tw-grid-cols-2 tw-text-md tw-leading-6 tw-px-1">
                        <div className="tw-py-1 tw-text-gray-600">Tiền thuế GTGT</div>
                        <div className="tw-py-1 tw-text-right">+ {formatCurrency(amountTax)}</div>
                    </div>
                </>
            )}

            <div className="tw-h-px tw-w-full tw-bg-secondary/50" />

            <div className="tw-grid tw-grid-cols-2 tw-px-1 tw-text-md tw-font-semibold tw-text-gray-900">
                <div className="tw-py-1.5">Tổng đơn hàng</div>
                <div className="tw-py-1.5 tw-text-right">{formatCurrency(isOpenState ? totalPrice : finalPrice)}</div>
            </div>
        </div>
    );
};

export default Summary;
